import * as Yup from 'yup';

export const userPermissionsValidationSchema = Yup.object().shape({
  taggedItemsOption : Yup.string().nullable(),
  chatAccess        : Yup.boolean().nullable(),
  editAboutMe       : Yup.boolean().nullable(),
  geoLocationAccess : Yup.array().of(Yup.string()).nullable(),
  aboutMeAccess     : Yup.array().of(Yup.string()).nullable(),
});

